/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Capture_Hints_TitleInputs */

const en_us2_body_assessment_capture_hints_title = /** @type {(inputs: Body_Assessment_Capture_Hints_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you shoot`)
};

const pt_br2_body_assessment_capture_hints_title = /** @type {(inputs: Body_Assessment_Capture_Hints_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes de tirar`)
};

const es_419_body_assessment_capture_hints_title = /** @type {(inputs: Body_Assessment_Capture_Hints_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes de tomarlas`)
};

const pt_pt2_body_assessment_capture_hints_title = /** @type {(inputs: Body_Assessment_Capture_Hints_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes de tirares`)
};

const fr_fr2_body_assessment_capture_hints_title = /** @type {(inputs: Body_Assessment_Capture_Hints_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avant la photo`)
};

const de_de2_body_assessment_capture_hints_title = /** @type {(inputs: Body_Assessment_Capture_Hints_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevor du loslegst`)
};

const it_it2_body_assessment_capture_hints_title = /** @type {(inputs: Body_Assessment_Capture_Hints_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima di scattare`)
};

/**
* | output |
* | --- |
* | "Before you shoot" |
*
* @param {Body_Assessment_Capture_Hints_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_capture_hints_title = /** @type {((inputs?: Body_Assessment_Capture_Hints_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Capture_Hints_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_capture_hints_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_capture_hints_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_capture_hints_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_capture_hints_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_capture_hints_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_capture_hints_title(inputs)
	return en_us2_body_assessment_capture_hints_title(inputs)
});
export { body_assessment_capture_hints_title as "body-assessment.capture_hints_title" }